module.exports = __webpack_public_path__ + "img/telgrame_new.03e5071d.png";